import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// VO == on-screen caption. Every claim is grounded in EAKC-MVP's 2026-06-12 polish pass:
//   FIX 1 — temporal queries ("latest", "last N days", "recently") are never written to
//     the 30-min semantic response cache (you can't serve a stale answer you never stored).
//   FIX 2 — the changelog tool counted `agent_output` rows (the chat's OWN answers,
//     re-ingested) as "new sources" — 30 sources / 16,690 chunks were mostly self-talk.
//   FIX 3 — CRAG graded the retrieved chunks INCORRECT while a live date tool answered
//     perfectly; the pointless broader-search escalation wasted ~3-23s.
//   FIX 4 — answers ballooned past 3,000 words with unsolicited "YouTube Content Ideas"
//     and marketing roadmaps; a scope-discipline rule keeps depth, drops the padding.
// No fabricated numbers — 30/16,690, 3,000+ words, the 30-min TTL, and the ~3-23s
// escalation cost are the real figures.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 5.0, caption: "The crashes are fixed. The pipeline is green. Every test passes." },
  { scene: "hook", fromSec: 5.5, holdSec: 5.0, caption: "Then you ask: what's new in the last four days? And four subtle things are still off." },
  { scene: "hook", fromSec: 11, holdSec: 4.0, caption: "No error. No stack trace. The system runs perfectly — and is quietly wrong." },
];

export const FIX1: ScriptLine[] = [
  { scene: "fix1", fromSec: 0.3, holdSec: 6, caption: "Fix one: don't cache time. A response cache with a thirty-minute TTL would happily store that answer." },
  { scene: "fix1", fromSec: 6.5, holdSec: 6, caption: "But 'the last four days' is relative — cache it now and tomorrow it's a stale, confidently-wrong reply." },
  { scene: "fix1", fromSec: 13, holdSec: 5, caption: "So detect temporal queries — latest, last N days, recently — and never cache them. You can't serve a stale answer you never stored." },
];

export const FIX2: ScriptLine[] = [
  { scene: "fix2", fromSec: 0.3, holdSec: 6, caption: "Fix two: count real work, not your own questions. The changelog bragged: thirty new sources, sixteen thousand new chunks." },
  { scene: "fix2", fromSec: 6.5, holdSec: 6, caption: "But most of those 'new sources' were agent_output — the chat's OWN answers, re-ingested as knowledge." },
  { scene: "fix2", fromSec: 13, holdSec: 5, caption: "It was counting the user's questions as accomplishments. Fix: exclude agent_output from the changelog counts." },
];

export const FIX3: ScriptLine[] = [
  { scene: "fix3", fromSec: 0.3, holdSec: 6, caption: "Fix three: grade the right thing. The quality gate, CRAG, marked the retrieved chunks INCORRECT." },
  { scene: "fix3", fromSec: 6.5, holdSec: 6, caption: "Then a live date tool answered the question perfectly. The gate judged retrieval when a TOOL supplied the answer." },
  { scene: "fix3", fromSec: 13, holdSec: 5, caption: "It wasted three to twenty-three seconds on a pointless broader search. Fix: for temporal queries, defer to the tool — skip CRAG, pass through." },
];

export const FIX4: ScriptLine[] = [
  { scene: "fix4", fromSec: 0.3, holdSec: 6, caption: "Fix four: answer the question, then stop. Replies ballooned past three thousand words." },
  { scene: "fix4", fromSec: 6.5, holdSec: 6, caption: "It appended 'Potential YouTube Content Ideas' and marketing roadmaps the user never asked for." },
  { scene: "fix4", fromSec: 13, holdSec: 5, caption: "Fix: a scope-discipline rule. Depth on the asked question is good. Tangential padding is not." },
];

export const RECAP: ScriptLine[] = [
  { scene: "recap", fromSec: 0.3, holdSec: 6, caption: "Four fixes, one theme: caching time, counting noise, grading the wrong artifact, and over-answering." },
  { scene: "recap", fromSec: 6.5, holdSec: 5, caption: "None of them crashed anything. Every one made the system feel a little less trustworthy." },
];

export const LESSON: ScriptLine[] = [
  { scene: "lesson", fromSec: 0.3, holdSec: 6, caption: "The hardest bugs after the crashes are the ones with no stack trace." },
  { scene: "lesson", fromSec: 6.5, holdSec: 5.5, caption: "Where the system runs perfectly and is quietly wrong. Fixing those is what makes a RAG system feel trustworthy." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.3, holdSec: 5, caption: "Works, but wrong. The crash is loud — the correctness bug just smiles and lies." },
  { scene: "outro", fromSec: 5.5, holdSec: 3.8, caption: "That's the series — it's all open: the repo, the migrations, the dashboard. Build in public, break in production." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
